import { render } from "./BasicButton.vue?vue&type=template&id=3b98cfe5&scoped=true"
import script from "./BasicButton.vue?vue&type=script&lang=js"
export * from "./BasicButton.vue?vue&type=script&lang=js"

import "./BasicButton.vue?vue&type=style&index=0&id=3b98cfe5&scoped=true&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b98cfe5"]])

export default __exports__